import clsx from 'clsx';

import { useFormatText } from '@/hooks/useFormatText';
import { useSettingsStore } from '@/store/useSettingsStore';
import { TLanguage } from '@/types';

const LanguageSwitcher = () => {
  const { settings, updateSettings } = useSettingsStore();
  const currentLang = settings.language;
  const { formatText } = useFormatText();

  const handleLanguageChange = (lang: TLanguage) => {
    updateSettings({
      language: lang,
      direction: lang === 'ar' ? 'rtl' : 'ltr',
    });
  };

  const languages: { code: TLanguage; label: string; flag: string }[] = [
    { code: 'en', label: 'header.en-code', flag: '/assets/svg/uk.svg' },
    { code: 'ar', label: 'header.ar-code', flag: '/assets/svg/ar.svg' },
  ];

  return (
    <div className="flex bg-neutral-100 p-1 rounded-lg ">
      {languages.map((lang) => (
        <button
          key={lang.code}
          onClick={() => handleLanguageChange(lang.code)}
          className={clsx(
            'flex items-center gap-2 px-3 py-1.5 rounded-md transition-all duration-200 cursor-pointer',
            currentLang === lang.code
              ? 'bg-white shadow-sm font-semibold text-neutral-primary'
              : 'text-neutral-secondary hover:text-neutral-primary'
          )}
        >
          <img
            src={lang.flag}
            alt={lang.label}
            className="w-5 h-5 object-cover"
          />
          <span className="text-xs">{formatText(lang.label)}</span>
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
